import Disbs from './Disbursement';

export default Disbs;
